import type { UserLicenseTypeSelectProps } from './UserLicenseTypeSelect';

type LicenseType = UserLicenseTypeSelectProps['value'];

export type InputDetailVariant =
  | 'ADOBE_MANAGED_DETAILS'
  | 'FOLDER_DETAILS'
  | 'INVALID_EMAIL_DETAILS'
  | 'MEMBER_SEAT_LIMIT_DETAILS'
  | 'GUEST_SEAT_LIMIT_DETAILS'
  | 'NEW_MEMBER_DETAILS';

export type GetInputDetailVariantArgs = {
  guestSeatLimit?: number | null;
  hasNewMembers?: boolean;
  includedMemberSeatsAvailable: number;
  invalidEmail: boolean;
  isManagedByAdobe?: boolean;
  licenseType: LicenseType;
  memberSeatLimit?: number;
  memberSeatRate?: string;
  resourceType?: string;
  seatLimit?: number | null;
  totalNewUsers?: number;
};

export const getInputDetailVariant = ({
  guestSeatLimit,
  hasNewMembers,
  includedMemberSeatsAvailable,
  invalidEmail,
  isManagedByAdobe,
  licenseType,
  memberSeatLimit,
  memberSeatRate,
  resourceType,
  seatLimit,
  totalNewUsers = 0,
}: GetInputDetailVariantArgs): InputDetailVariant | undefined => {
  if (resourceType === 'FolderAsset' && hasNewMembers) {
    return 'FOLDER_DETAILS';
  }

  if (invalidEmail) {
    return 'INVALID_EMAIL_DETAILS';
  }

  if (isManagedByAdobe && hasNewMembers) {
    return 'ADOBE_MANAGED_DETAILS';
  }

  if (memberSeatLimit) {
    return 'MEMBER_SEAT_LIMIT_DETAILS';
  }

  if (
    memberSeatRate &&
    seatLimit &&
    totalNewUsers > includedMemberSeatsAvailable &&
    licenseType === 'MEMBER'
  ) {
    return 'NEW_MEMBER_DETAILS';
  }

  if (guestSeatLimit) {
    return 'GUEST_SEAT_LIMIT_DETAILS';
  }

  return undefined;
};
